import { Helmet } from "react-helmet-async";
import { Hero } from "../components/Hero";
import { WhoIWorkWith } from "../components/WhoIWorkWith";
import { About } from "../components/About";
import { Skills } from "../components/Skills";
import { Projects } from "../components/Projects";
import { MobileApps } from "../components/MobileApps";
import { Services } from "../components/Services";
import { Experience } from "../components/Experience";
import { Contact } from "../components/Contact";

export default function HomePage() {
  return (
    <main data-testid="home-page">
      <Helmet>
        <title>AI Software Development | Web Development | Mobile Apps | Ricky Sokhi</title>
        <link rel="canonical" href={`${typeof window !== "undefined" ? window.location.origin : ""}/`} />
      </Helmet>
      <Hero />
      <WhoIWorkWith />
      <About />
      <Skills />
      <Projects />
      <MobileApps />
      <Services />
      <Experience />
      <Contact />
    </main>
  );
}
